<template>
    <applications-applicants-store
        :store-on-created="true"
        :params="{
            application: $route.params.application,
            applicant: $route.query.applicant,
            tenant: $route.query.tenant
        }"
        v-slot="{
            error,
            store
        }"
        @success="onSuccess"
    >
        <div class="py-6">
            <base-loading
                :retry="store"
                :error="error"
            />

            <error-modal
                v-if="error && $error.is(error, { exclude: [403] })"
                :error="error"
            />
        </div>
    </applications-applicants-store>
</template>

<script>
    import ApplicationsApplicantsStore from '../../../components/applications-applicants-store'

    export default {
        components: {
            ApplicationsApplicantsStore
        },
        methods: {
            onSuccess ({ data: applicant }) {
                this.$router.push({
                    name: 'applications.applicants.details.edit',
                    params: {
                        applicant: applicant.uuid
                    }
                })
            }
        }
    }
</script>
